/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Country_Count_PluralInputs */

const bn_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} দেশ`)
};

const de_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Länder`)
};

const el_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} χώρες`)
};

const en_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} countries`)
};

const es_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} países`)
};

const fr_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pays`)
};

const hi_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} देश`)
};

const hu_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} országban`)
};

const id_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} negara`)
};

const it_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} paesi`)
};

const ja_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} か国`)
};

const ko_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 국가`)
};

const nl_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} landen`)
};

const pl_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kraje`)
};

const pt_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} países`)
};

const ru_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} стран`)
};

const sv_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} länder`)
};

const tr_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ülke`)
};

const uk_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} країни`)
};

const vi_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} quốc gia`)
};

const zh_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个国家`)
};

const zh_hant_country_count_plural = /** @type {(inputs: Country_Count_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個國家`)
};

/**
* | output |
* | --- |
* | "{count} countries" |
*
* @param {Country_Count_PluralInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const country_count_plural = /** @type {((inputs: Country_Count_PluralInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Country_Count_PluralInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_country_count_plural(inputs)
	if (locale === "de") return de_country_count_plural(inputs)
	if (locale === "el") return el_country_count_plural(inputs)
	if (locale === "en") return en_country_count_plural(inputs)
	if (locale === "es") return es_country_count_plural(inputs)
	if (locale === "fr") return fr_country_count_plural(inputs)
	if (locale === "hi") return hi_country_count_plural(inputs)
	if (locale === "hu") return hu_country_count_plural(inputs)
	if (locale === "id") return id_country_count_plural(inputs)
	if (locale === "it") return it_country_count_plural(inputs)
	if (locale === "ja") return ja_country_count_plural(inputs)
	if (locale === "ko") return ko_country_count_plural(inputs)
	if (locale === "nl") return nl_country_count_plural(inputs)
	if (locale === "pl") return pl_country_count_plural(inputs)
	if (locale === "pt") return pt_country_count_plural(inputs)
	if (locale === "ru") return ru_country_count_plural(inputs)
	if (locale === "sv") return sv_country_count_plural(inputs)
	if (locale === "tr") return tr_country_count_plural(inputs)
	if (locale === "uk") return uk_country_count_plural(inputs)
	if (locale === "vi") return vi_country_count_plural(inputs)
	if (locale === "zh") return zh_country_count_plural(inputs)
	return zh_hant_country_count_plural(inputs)
});